import i18n from '../utils/i18n';

/**
 * Fix / Hacks
 * 1. Desde css Modal tiene seteado opacity: 0; para evitar "pantallazo", ahora
 *    necesitamos agregarle por js opacity: 1; y eliminárselo solo cuando se hayan
 *    terminado las animaciones, de lo contrario no se apreciarían las del closeModal.
 */

const newsletters = document.querySelectorAll( '.newsletter' );

const Constructor = () => {
    newsletters.forEach( newsletter => {
        Newsletter( newsletter );
    });
}

const Newsletter = ( $el ) => {

    if( !$el ) return;

    const $input              = $el.querySelector( 'input' );
    const $hint               = $el.querySelector( '.newsletter__hint' );
    const FormBtnSubmit       = $el.querySelector( '.newsletter__submit' );
    const BtnSubmitText       = FormBtnSubmit && FormBtnSubmit.querySelector( '.button__text' );
    const backupBtnSubmitText = BtnSubmitText && BtnSubmitText.textContent;
    const isPopup             = $el.classList.contains( 'newsletter--fixed' );
    const btnClose            = isPopup && $el.querySelector( '.newsletter__close' );
    const messages            = i18n.forms;
    let message               = {};
    let lang                  = document.documentElement.lang || 'en-US';
    let lastScrollY           = 0;
    let ticking               = null;

    switch ( lang ) {
        case 'es-ES':
        case 'es-AR':
            message = messages.es_ar;
        break;
        default:
            message = messages.en_us;
        break;
    }

    const isValidEmail = ( email ) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test( email.value.toLowerCase() );
    }

    const handleFocusIn = () => {
        $input.parentNode.classList.add( 'newsletter__field--active' );
    }

    const handleOnClick = () => {
        setCookie( 'ic_suscribe', 'true', 1 );
        $el.classList.remove( 'newsletter--open' );

        $el.addEventListener( 'transitionend', function transitionEnd( e ) { /* 1 */
            e.currentTarget.removeEventListener( e.type, transitionEnd );
            $el.style.opacity = '0.001';
        });
    }

    const handleFocusOut = () => {
        if ( $input.value.length === 0 ) {
            $input.parentNode.classList.remove( 'newsletter__field--active' );
        }
    }

    function cleanInputError() {
        $hint.classList.remove( 'error' );
        $hint.innerHTML = '';
    }

    const addHint = ( status, message ) => {
        $hint.removeAttribute( 'class' );
        $hint.classList.add( 'newsletter__hint' );
        $hint.classList.add( status );
        $hint.textContent = message;
    }

    const showSuccess = () => {
        $input.value = '';
        handleFocusOut();
        setButtonState( FormBtnSubmit, 'success' );
        setCookie( 'ic_suscribe', 'true' );
        cleanInputError();
    }

    const showError = () => {
        setButtonState( FormBtnSubmit, 'error' );
        addHint( 'error', message.global );
    }

    const handleSubmit = ( event ) => {
        event.preventDefault();
        let hasError = false;

        if ( ! isValidEmail( $input ) ) {
            hasError = true;
            addHint( 'error', message.email );
        }

        if ( ! hasError ) {
            const request = new XMLHttpRequest();
            request.onreadystatechange = function() {

                setButtonState( FormBtnSubmit, 'loading' );

                if ( request.readyState == 4 && request.status == 200) {
                    showSuccess();
                } else if( request.readyState == 4 && request.status != 200 ) {
                    // No mostramos error, por que cuando hay algún problema de CORS
                    // el suuario se registra correctamente pero el sitema le muestra
                    // un error.
                    showSuccess();
                }
            }
            request.open( "POST", $el.getAttribute( 'action' ) + '&EMAIL=' + $input.value, true );
            request.send();
        }
    }

    /**
     * Para que la función se ejecute correctamente el botón input tiene
     * que tener internamente <span> con la clase .button__text para
     * lograr la animación pertinente, por ejemplo:
     *
     * <button type="submit" class="button button--invert">
     *      <span class="button__text">Get in touch</span>
     * </button>
     */
    function setButtonState( btn, state ) {

        if( !btn || !BtnSubmitText ) return;

        if( state === 'loading' ) {
            BtnSubmitText.textContent = message.loading;
            btn.classList.add( 'button--loading' );
            btn.disabled = true;
            return;
        }

        if( state === 'success' ) {
            BtnSubmitText.textContent = message.success;
            btn.classList.add( 'button--loaded' );

            setTimeout( function() {
                restoreButtonState( btn, backupBtnSubmitText );
            }, 4000 );
        }

        if( state === 'error' ) {
            restoreButtonState( btn, backupBtnSubmitText );
        }
    }

    function restoreButtonState( btn, txt ) {
        BtnSubmitText.textContent = txt;
        btn.classList.remove( 'button--loading' );
        btn.classList.remove( 'button--loaded' );
        btn.disabled = false;
    }

    function setCookie( name, value, days ) {
        let expires = '';
        if ( days ) {
            let date = new Date();
            date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + ( value || '' )  + expires + '; path=/';
    }

    function getCookie( name ) {
        let nameEQ = name + '=';
        let ca = document.cookie.split( ';' );
        for( let i=0; i < ca.length; i++ ) {
            let c = ca[i];
            while ( c.charAt( 0 ) == ' ' ) c = c.substring( 1, c.length );
            if ( c.indexOf( nameEQ ) == 0) return c.substring( nameEQ.length, c.length );
        }
        return null;
    }

    function onScroll() {
        lastScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        requestTick();
    }

    function requestTick() {
        if( !ticking ) {
            requestAnimationFrame( update );
            ticking = true;
        }
    }

    function update() {
        if ( lastScrollY > 970 ) {
            $el.classList.add( 'newsletter--open' );
            $el.style.opacity = '1'; /* 1 */
            window.removeEventListener( 'scroll', onScroll, false );
        }
        ticking = false;
    }

    $input.addEventListener( 'focus', handleFocusIn, false );
    $input.addEventListener( 'focusout', handleFocusOut, false );
    $el.addEventListener( 'submit', handleSubmit, true );

    if( isPopup && btnClose ) {
        btnClose.addEventListener( 'click', handleOnClick, false );
    }

    if ( isPopup && getCookie( 'ic_suscribe' ) != 'true' ) {
        // window.addEventListener( 'load', onScroll, false );
        window.addEventListener( 'scroll', onScroll, false );
    }
}

export default Constructor;